import React, { useEffect, useState } from "react";
import { getPosSales } from "../../../../services/sales/posService";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";

function SearchSalesPos({
  outletID = 0,
  onSelectSalesPos,
  showAmount = false,
}) {
  const { reload } = useGlobalData();
  async function getPosSalesData(outletID) {
    const response = await getPosSales(outletID);
    const { data } = response.data;
    setSalesPosList(data.salesPos);
  }
  useEffect(() => {
    getPosSalesData(outletID);
  }, [outletID, reload]);
  const [salesPosList, setSalesPosList] = useState([]);
  return (
    <CustomDataTableSearch
      data={salesPosList}
      onRefreshData={() => {
        getPosSalesData(outletID);
      }}
      onSelectedData={(salesPos) => {
        if (onSelectSalesPos) {
          onSelectSalesPos(salesPos);
        }
      }}
      columns={[
        {
          header: "POS ID",
          field: "ID",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Outlet Name",
          field: "outlet.outletName",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Sales Date",
          field: "salesDate",
          body: (rowData) => formatDate(rowData.salesDate),
          sortable: true,
          filter: true,
        },
        {
          header: "Customer Name",
          field: "customer.customerName",
          body: null,
          sortable: true,
          filter: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          filter: true,
          hidden: true,
        },
        {
          header: "Sales Amount",
          field: "total",
          body: (rowData) => (
            <NumberFormat
              value={rowData.total}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
          filter: true,
        },
      ]}
    />
  );
}

export default SearchSalesPos;
